import { SVGProps } from "react";

export default function DownloadTrayIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#333333", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.5 3.125H5.75983C4.93669 3.125 4.20981 3.66185 3.96774 4.44859L1.95791 10.9805C1.90295 11.1592 1.875 11.345 1.875 11.5319V15C1.875 16.0355 2.71447 16.875 3.75 16.875H16.25C17.2855 16.875 18.125 16.0355 18.125 15V11.5319C18.125 11.345 18.0971 11.1592 18.0421 10.9805L16.0323 4.44859C15.7902 3.66185 15.0633 3.125 14.2402 3.125H12.5M1.875 11.25H5.09119C5.80138 11.25 6.45063 11.6513 6.76824 12.2865L6.98176 12.7135C7.29937 13.3487 7.94862 13.75 8.65881 13.75H11.3412C12.0514 13.75 12.7006 13.3487 13.0182 12.7135L13.2318 12.2865C13.5494 11.6513 14.1986 11.25 14.9088 11.25H18.125M10 2.5V9.375M12.5 6.875L10 9.375L7.5 6.875"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
